import { Directive } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appValidEmailValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidateEmailPatternDirective,
            multi: true
        }
    ],
    standalone: false
})
export class ValidateEmailPatternDirective implements Validator {
  private static validateEmailPattern(control: UntypedFormControl): ValidationErrors | null {
    const emailRegex: RegExp = new RegExp(
      '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]' +
      '{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$'
    );

    const value = control.value;

    if (!value) {
      return null;
    }

    if (!emailRegex.test(value)) {
      return { invalidEmail: 'Not a valid email address' };
    }
    return null;
  }

  constructor() { }

  public validate(c: UntypedFormControl): { [key: string]: ValidationErrors | null } {
    return ValidateEmailPatternDirective.validateEmailPattern(c);
  }
}
